import React, { useState } from 'react'
import AloModal from 'components_v1/AloModal'
import './OneTimePasscodeModal.scss'
import ForgotPasswordStep1 from './ForgotPasswordStep1'
import ForgotPasswordStep2 from './ForgotPasswordStep2'
import { axios } from 'api'
import { Feedback } from 'ui/bend'
import { useAlert } from 'hooks'

const ContentModalFP = ({
  show,
  setCustomerEmail,
  fromPage,
  iosAppQueryParams,
  onHide
}) => {
  const [step, setStep] = useState(1)
  const [email, setEmail] = useState()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [invalidEmail, setInvalidEmail] = useState(false)
  const [error, setError] = useState()
  const [isBlocked, setIsBlocked] = useState(false)
  const setAlert = useAlert()

  const resetPassword = async (data) => {
    if (isSubmitting) return
    setEmail(data?.email)
    setIsSubmitting(true)
    try {
      // replace with url to mail otp
      const res = await axios.post(
        fromPage === 'verify'
          ? '/sso/send_shopify_login_otp'
          : '/sso/send_login_otp',
        {
          ...data,
          ...iosAppQueryParams
        }
      )
      const { message } = res.data
      if (step === 2) {
        setAlert(
          {
            message
          },
          {
            autoClose: 5000
          }
        )
      }
      if (message === 'OTP sent successfully') {
        setStep(2)
        setError(false)
        setIsBlocked(false)
      } else if (message === 'Too many requests. Please try again later.') {
        setError(message)
      } else {
        setInvalidEmail(
          String(message).toLowerCase() === 'account not found'
            ? 'The email you entered is either incorrect or not in our records'
            : message
        )
      }
    } catch (error) {
      console.log(error)
      setError(error?.response?.data?.message)
    } finally {
      setIsSubmitting(false)
    }
  }
  return (
    <AloModal
      className='one-time-passcode-modal'
      backdrop={true}
      show={show}
      onHide={() => onHide()}
    >
      {step === 1 && (
        <ForgotPasswordStep1
          invalidEmail={invalidEmail}
          isSubmitting={isSubmitting}
          resetPassword={resetPassword}
          fromPage={fromPage}
        />
      )}
      {step === 2 && (
        <ForgotPasswordStep2
          email={email}
          resending={isSubmitting}
          resetPassword={() => resetPassword({ email })}
          setStep={setStep}
          setCustomerEmail={setCustomerEmail}
          fromPage={fromPage}
          iosAppQueryParams={iosAppQueryParams}
          setError={setError}
          isBlocked={isBlocked}
          setIsBlocked={setIsBlocked}
        />
      )}
      {error && (
        <Feedback
          className='error'
          style={{ textAlign: 'center', marginBottom: '8px' }}
        >
          {error}
        </Feedback>
      )}
    </AloModal>
  )
}

export default ContentModalFP
